import { createSelector } from '@reduxjs/toolkit';

import { resourceSelectors } from '../../utils/resourceSelectors';

export const [
  portfolioIndicesAllIds,
  portfolioIndicesById,
  allPortfolioIndicesSelector,
  portfolioIndicesMetadataSelector,
] = resourceSelectors('portfolioIndices');
